import axios from "axios";

export const CamsPayRepository = axios.create({
  baseURL: "https://uat.camspay.com",
  headers: {
    "Content-Type": "application/json"
  }
});
